window.addEventListener('load', function() {
          // Set a timeout to delay image loading
          console.log('page loaded, now setting to eager');
          setTimeout(() => {
              const images = document.querySelectorAll('.true-img');
              images.forEach(image => {
                  image.loading = 'eager';
              });
          }, 100); // Adjust the delay as needed
      });